module.exports = __webpack_public_path__ + "img/Circus25.17b22341.jpg";